import { FormControl } from "@mui/material";
import { LocalizationProvider, renderTimeViewClock, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { IDateField } from "../../../../utils/interfaces";
import {format} from "date-fns";

export const TimeField = ({
    id,
    error,
    label,
    placeholder,
    required,
    inputClassName,
    helperClassName,
    formClassName,
    labelClassName,
    formik,
    setError
  }: IDateField) => {
  return <FormControl className={formClassName}>
  <>
    <p className={labelClassName}>{label}</p>{required && <span>*</span>}
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        className={inputClassName}
        format="HH:mm"
        viewRenderers={{
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        }}
        onError={(newError) => setError(newError)}
        onChange={(newValue) => {
          formik.setFieldValue(id, format(Date.parse(newValue), 'HH:mm'))
        }}
        slotProps={{
          textField: {
            id,
            name: id,
            placeholder,
            variant: "outlined",
            error: Boolean(error),
            helperText: error && "Your date is not valid",
            FormHelperTextProps: {
              classes: {
                root: helperClassName
              }
            }
          }
        }}
        value={formik.values[id]}
      />
    </LocalizationProvider>
  </>
</FormControl>
}